"use client";

import { FAQComponentProps } from "./props";
import { Vehicle } from "@/components/package-components/types";
import { StockType } from "@/components/package-components/lib/faq/props";
import { generateFaq } from "@/components/package-components/lib/faq";
import { FAQVariant01 } from "./variants/01";
import { handleFormatStyleString } from "@/components/package-components/utils";
import FaqJsonLd from "@/components/package-components/non-editable/SEO/faq-jsonld";
import { WebsitePreferenceType } from "@prisma/client";

export const FAQ = (props: FAQComponentProps) => {
  const variant = Number(props?.variants?.value) ?? 1;

  const primaryRegion: string =
    props.data.site?.preferences
      ?.find((item) => item.type === WebsitePreferenceType.localSeoSlug)
      ?.value?.split(",")[0]
      ?.trim() ?? "Brasil";

  const hasMotorcycleInventory: boolean = (props.data?.vehicleList ?? []).some(
    (v: Vehicle) => v.type?.toLowerCase() === "motorcycle"
  );

  const hasCarInventory: boolean = (props.data?.vehicleList ?? []).some(
    (v: Vehicle) => v.type?.toLowerCase() === "car"
  );

  const inventoryType = (): StockType => {
    if (hasMotorcycleInventory && hasCarInventory) {
      return "mixed";
    } else if (hasMotorcycleInventory) {
      return "motorcycle";
    }

    return "car";
  };

  const faq = generateFaq({
    name: props.data.site?.siteName ?? "",
    city: primaryRegion,
    stockType: inventoryType(),
  });

  function renderVariant(): JSX.Element {
    switch (variant) {
      case 1:
        return <FAQVariant01 {...props} faq={faq} />;
      default:
        return <FAQVariant01 {...props} faq={faq} />;
    }
  }

  return (
    <>
      {props?.styles?.value && (
        <style>
          {handleFormatStyleString(
            props.styles.value,
            props.id,
            props.styles.classes
          )}
        </style>
      )}

      <FaqJsonLd items={faq} />

      {renderVariant()}
    </>
  );
};
